import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';
import FormattedCountryName from '@app/shop/components/FormattedCountryName';
import {
  Magento2_ProductStockStatus as STOCK_STATUS,
  Magento2_ProductStockStatus,
} from '@__generated__/globalTypes';

import { StockDotGreen, StockDotRed } from './styles';
import messages from './StockMessage.messages';

export enum PACKAGE_TYPE {
  BOX = 'BOX',
  DL = 'DL',
}

const StockMessage: FunctionComponent<{
  packageType?: PACKAGE_TYPE | null;
  stockStatus?: Magento2_ProductStockStatus | null;
  countryCode?: string | null;
}> = ({ packageType, stockStatus, countryCode }) => {
  if (packageType === PACKAGE_TYPE.DL) {
    return (
      <Box data-testid="stock-message-dl-in-stock">
        <StockDotGreen />
        <FormattedMessage {...messages.downloadStock} />
      </Box>
    );
  }
  if (packageType === PACKAGE_TYPE.BOX) {
    switch (stockStatus) {
      case STOCK_STATUS.IN_STOCK: {
        return (
          <Box data-testid="stock-message-box-in-stock">
            <Box data-testid="stock-message-box-free-shipping">
              <b>
                <FormattedMessage {...messages.freeShipping} />:
              </b>{' '}
              (<FormattedCountryName code={countryCode} />)
            </Box>
            <Box my={15}>
              <StockDotGreen />
              <FormattedMessage {...messages.inStock} />
            </Box>
            <FormattedMessage {...messages.inStockDescription} />
          </Box>
        );
      }
      case STOCK_STATUS.OUT_OF_STOCK: {
        return (
          <Box data-testid="stock-message-box-out-of-stock">
            <Box my={15}>
              <StockDotRed />
              <FormattedMessage {...messages.outOfStock} />
            </Box>
          </Box>
        );
      }
      default: {
        return null;
      }
    }
  }
  return null;
};

export default StockMessage;
